export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-export-pdf-872861613146c764844d5a2309cb6395.svg";